<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      show-save-button
      unit="阶梯BOM"
      edit-title
      id-key="UserId"
      :data="data"
      :line-form="true"
      form-label-width="100px"
      @close-saved="$emit('close-saved')"
      label-position="left"
    >
      <template slot="form">
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="BOM版本号" prop="BOM">
                <el-input
                  clearable
                  v-model="data.BOM"
                  placeholder="请输入方案名称"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="存货名称" prop="StocksName">
                <el-select
                  v-model="data.StocksName"
                  placeholder="请选择存货"
                  clearable
                >
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="存货编码" prop="StocksCode">
                <span></span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="颜色" prop="Color">
                <el-select
                  v-model="data.Color"
                  placeholder="请选择颜色"
                  clearable
                >
                  <el-option
                    v-for="item in colorOption"
                    :key="item.key"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位" prop="Unit">
                <span></span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="数量" prop="quantity">
                <el-input-number
                  :min="1"
                  clearable
                  v-model="data.quantity"
                  placeholder="请输入数值"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否默认" prop="IsDefault">
                <el-checkbox v-model="data.IsDefault"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <el-tabs tab-position="top" type="card" @tab-click="tabClick">
          <el-tab-pane label="组合BOM">
            <wj-combination
              :table-data="combinationData"
              :sub-table-data="subCombinationData"
            />
          </el-tab-pane>
          <el-tab-pane label="装配BOM">
            <wj-assemble
              :table-data="assembleData"
              :sub-table-data="subAssembleData"
            />
          </el-tab-pane>
          <el-tab-pane label="配件BOM">
            <wj-fittings
              :table-data="fittingsData"
              :sub-table-data="subFittingsData"
            />
          </el-tab-pane>
          <el-tab-pane label="特殊工艺BOM">
            <wj-special  
            :table-data="specialData"
              :sub-table-data="subSpecialData" />
          </el-tab-pane>
          <el-tab-pane label="注胶BOM">
            <wj-glue
              :table-data="glueData"
              :sub-table-data="subGlueData" />
          </el-tab-pane>
        </el-tabs>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import wjCombination from "./wjCombination";
import wjAssemble from "./wjAssemble";
import wjFittings from "./wjFittings";
import wjSpecial from "./wjSpecial";
import wjGlue from "./wjGlue";

import {
  bomListDialogCombinationApi,
  bomListDialogAssembleApi,
  bomListDialogFittingsApi,
  bomListDialogSpecialApi,
  bomListDialogGlueApi,
} from "@/data/production/test";

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    wjCombination,
    wjAssemble,
    wjFittings,
    wjSpecial,
    wjGlue,
  },
  data() {
    return {
      colorApi: require("@/api/ba/color").default,
      combinationApi: bomListDialogCombinationApi,
      assembleApi: bomListDialogAssembleApi,
      fittingsApi: bomListDialogFittingsApi,
      specialApi: bomListDialogSpecialApi,
      glueApi: bomListDialogGlueApi,
      colorOption: [],
      combinationData: [],
      subCombinationData: [],
      assembleData: [],
      subAssembleData: [],
      fittingsData: [],
      subFittingsData: [],
      specialData: [],
      subSpecialData: [],
      glueData: [],
      subGlueData: [],
      data: {
        BOM: "",
        StocksName: "",
        StocksCode: "",
        Color: "",
        quantity: "",
        Unit: "",
        IsDefault: "",
      },
    };
  },
  created() {
    this.colorApi.list({}).then((res) => {
      if (res.Code === 0) {
        let data = res.Data;
        this.colorOption = data.map((item) => {
          return {
            key: item.ColorId,
            label: item.ColorName,
            value: item.ColorId,
          };
        });
      }
    });
    this.getCombinationApi();
  },

  methods: {
    getCombinationApi() {
      this.combinationApi.list().then((res) => {
        if (res.Code === 0) {
          this.subCombinationData = [];
          this.combinationData = [];

          res.Data.forEach((item) => {
            this.subCombinationData.push({
              name: item.Name,
              child: item.child,
            });

            this.combinationData.push({
              Name: item.Name,
              Model: item.Model,
              Unit: item.Unit,
              Quantity: item.Quantity,
              Img: item.Img,
              Stage: item.Stage,
              Inventory: item.Inventory,
              BomVesion: item.BomVesion,
            });
          });
        }
      });
    },
    getAssembleApi() {
      this.assembleApi.list().then((res) => {
        if (res.Code === 0) {
          this.assembleData = [];
          this.subAssembleData = [];

          res.Data.forEach((item) => {
            this.subAssembleData.push({
              name: item.Name,
              child: item.child,
            });

            this.assembleData.push({
              Name: item.Name,
              Model: item.Model,
              Unit: item.Unit,
              Color: item.Color,
              Quantity: item.Quantity,
              Img: item.Img,
              Stage: item.Stage,
              Inventory: item.Inventory,
              BomVesion: item.BomVesion,
            });
          });
        }
      });
    },
    getFittingsApi() {
      this.fittingsApi.list().then((res) => {
        if (res.Code === 0) {
          this.fittingsData = [];
          this.subFittingsData = [];

          res.Data.forEach((item) => {
            this.subFittingsData.push({
              name: item.Name,
              child: item.child,
            });

            this.fittingsData.push({
              Code: item.Code,
              Name: item.Name,
              Model: item.Model,
              Unit: item.Unit,
              Quantity: item.Quantity,
              Img: item.Img,
              remark: item.remark,
              Inventory: item.Inventory,
              BomVesion: item.BomVesion,
            });
          });
        }
      });
    },
    getSpecialApi(){
      this.specialApi.list().then((res) => {
        if (res.Code === 0) {
          this.specialData = [];
          this.subSpecialData = [];

          res.Data.forEach((item) => {
            this.subSpecialData.push({
              name: item.Name,
              child: item.child,
            });

            this.specialData.push({
              Code: item.Code,
              Name: item.Name,
              Model: item.Model,
              Attr: item.Attr,
              Color: item.Color,
              Unit: item.Unit,
              Quantity: item.Quantity,
              Img: item.Img,
              remark: item.remark,
            });
          });
        }
      });
    },
    getGlue(){
      this.glueApi.list().then((res) => {
        if (res.Code === 0) {
          this.glueData = [];
          this.subGlueData = [];

          res.Data.forEach((item) => {
            this.subGlueData.push({
              name: item.Name,
              child: item.child,
            });

            this.glueData.push({
              Code: item.Code,
              Name: item.Name,
              GrossWeight: item.GrossWeight,
              NetWeight: item.NetWeight,
              oneOut: item.oneOut,
              Quantity: item.Quantity,
              Img: item.Img,
              remark: item.remark,
              BomVesion: item.BomVesion,
            });
          });
        }
      });
    },
    tabClick({ index }) {
      switch (index) {
        case "0":
          this.getCombinationApi();
          break;
        case "1":
          this.getAssembleApi();
          break;
        case "2":
          this.getFittingsApi();
          break;
        case '3':
          this.getSpecialApi();
          break;
        case '4':
          this.getGlue();
          break;
      }
    },
    save(row) {},
    viewImg(imgURL) {},
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  margin: 18px;
}
</style>
